module.exports = __webpack_public_path__ + "static/img/4329_phase_function_Paper_PointsHejduk_Prediction.78de069.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4329_phase_function_Paper_PointsHejduk_Prediction.png
// module id = anWe
// module chunks = 0